import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CaseService } from '../../services/case.service';
import { PatientCaseViewDataModel } from '../../models/patient/patient-case-view-data.model';
import { PatientCaseDataModel } from '../../models/patient/patient-case-data.model';
import { StaticDataService } from '../../services/static-data.service';
import { DoctorDataModel } from '../../models/doctors/doctor-data.model';
import { DoctorsService } from '../../services/doctors.service';
import { DoctorQueryOptionsModel } from '../../models/doctors/doctor-query-options.model';
import { TdoUserConfigurationModel } from '../../models/configuration/user/tdo-user-configuration.model';
import { TdoDropdownChange } from "../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change";
import { Globals } from "../../globals";
import { ToothPickerComponent } from 'src/app/modules/tdo-shared/tooth-picker/tooth-picker.component';
import { ToothConfigurationModel } from 'src/app/models/teeth/tooth-configuration.model';
import { CaseAddProcedureComponent } from 'src/app/modules/case-forms/case-add-procedure/case-add-procedure.component';
import { CaseForTooth, cfgCaseProcedure } from 'src/app/modules/ar/_models/ar.models';
import { PatientService } from 'src/app/modules/patient/patient.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CaseStatusEnum } from 'src/app/models/enum/case-status.enum';

@Component({
  selector: 'app-case-edit-dialog',
  templateUrl: './case-edit-dialog.component.html',
  styleUrls: ['./case-edit-dialog.component.scss']
})
export class CaseEditDialogComponent implements OnInit {
  // {caseItem: null, mode: 'newCase'};
  parentCaseId: string;
  model: PatientCaseViewDataModel;
  parentModel: PatientCaseViewDataModel;
  allCases: PatientCaseViewDataModel[] = [];
  tabSelected: number = 0;
  isLoading: boolean = false;
  isNewchildCase: boolean = false;
  isEditCaseForTooth: boolean = false;

  enumDoctorType_Provider = '00000004-1000-0000-0000-000000000001';
  enumDoctorType_Referring = '00000004-1000-0000-0000-000000000002';

  selectedTooth: ToothConfigurationModel = new ToothConfigurationModel();
  selectedCaseProcedure: cfgCaseProcedure = new cfgCaseProcedure();
  caseForToothModel: CaseForTooth;

  doctors: DoctorDataModel[] = [];
  doctorsRef: DoctorDataModel[] = [];  // referring doctors
  doctorPredicate: (data: DoctorDataModel) => string;
  casePredicate: (data: PatientCaseViewDataModel) => string;

  constructor(private dialogRef: MatDialogRef<CaseEditDialogComponent>,
    public staticDataService: StaticDataService,
    private caseService: CaseService,
    private doctorService: DoctorsService,
    private globals: Globals,
    private dialog: MatDialog,
    private patientService: PatientService,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      console.log("CaseEditDialog data", data);
    if (data.caseItem) {
      if (data.mode === 'editCase') {
        this.model = data.caseItem;
        this.parentCaseId = this.model.Case.ParentPatientCaseId;
        this.allCases = this.data.allCases;
        this.isNewchildCase = false;
      } else {
        // newChildCase
        this.isNewchildCase = true;
        this.allCases = this.data.allCases;
        this.model = new PatientCaseViewDataModel();
        this.parentModel = this.data.caseItem;
        this.model.Case = new PatientCaseDataModel();
        this.model.Case.ParentPatientCaseId = this.parentModel.PatientCaseId;
        this.model.Case.PatientId = this.globals.currentPatientId;
        this.model.Case.LOCID = parseInt(this.globals.LOCID);
        this.parentCaseId = this.parentModel.Case.PatientCaseId;
      }
    } else {
      if (data.mode === 'newCase') {
        this.model = new PatientCaseViewDataModel();
        this.model.Case = new PatientCaseDataModel();
        this.model.Case.PatientId = this.globals.currentPatientId;
        this.model.Case.LOCID = parseInt(this.globals.LOCID);
      }
      this.model.Case.enumCaseStatusID = CaseStatusEnum.Start;
    }

    this.caseForToothModel = new CaseForTooth();
    this.caseForToothModel.PatientId = this.globals.currentPatientId;
    this.caseForToothModel.enumCaseStatusID = CaseStatusEnum.Start;



  }

  ngOnInit(): void {
    this.isLoading = true;
    this.doctorPredicate = (data: DoctorDataModel) => {
      return 'Dr. ' + data.dataContact.LastName;
    };

    this.casePredicate = (data: PatientCaseViewDataModel) => {
      return data.Description + ' ' + data.DateString;
    };

    const options: DoctorQueryOptionsModel = new DoctorQueryOptionsModel();
    options.isIncludeTdo = true;
    options.isIncludeReferring = true;
    this.doctorService.getDoctors(options).subscribe((res) => {
      this.doctorsRef = res.sort((a, b) => a.dataContact.LastName?.localeCompare(b.dataContact.LastName));
      this.doctors = this.doctorsRef.filter(p => p.isActiveDoctor == true && p.enumDoctorTypeID == this.enumDoctorType_Provider);

      this.isLoading = false;
    });






    this.patientService.getPatientReferringDoctor(this.globals.currentPatientId).subscribe((res) => {
      if (res && res.DoctorId) {
        this.caseForToothModel.ReferralDoctorId = res.DoctorId;
        this.model.Case.ReferringDoctorId = res.DoctorId;
      }
    });



  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.isLoading=true;
    if (this.tabSelected === 1 || this.isNewchildCase) { // create Blank case
      this.caseService.saveCase(this.model).subscribe((res) => {
        this.dialogRef.close(true);
      });
    }
    else { // create case with tooth and procedure
      this.caseService.saveCaseforTooth(this.caseForToothModel).subscribe((res) => {
        localStorage.setItem('isSelectedMTI', 'false');    
        this.dialogRef.close(true);
      });
    }
    
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.tabSelected = tabChangeEvent.index;
  }

  getDoctor(DoctorID: string) {
    const doc = this.doctors?.find(p => p.DoctorId?.toLowerCase() === DoctorID?.toLowerCase());
    if (doc) {
      return doc;
    }

    return null;
  }

  getDoctorRef(ReferringDoctorID: string) {
    const doc = this.doctorsRef?.find(p => p.DoctorId?.toLowerCase() === ReferringDoctorID?.toLowerCase());
    if (doc) {
      return doc;
    }

    return null;
  }

  getParentCase() {
    const cse = this.allCases.find(p => p.PatientCaseId.toLowerCase() === this.parentCaseId.toLowerCase());
    if (cse) {
      return cse;
    }
  }

  onDoctorSelectionChange(event: TdoDropdownChange) {
    const doctor: DoctorDataModel = event.value;
    if (doctor) {
      //this.model.Case. = doctor.DoctorId;
      this.caseForToothModel.DoctorId = doctor.DoctorId;
    }
  }

  onReferringDoctorSelectionChange(event: TdoDropdownChange) {
    const doctor: DoctorDataModel = event.value;
    if (doctor) {
      this.model.Case.ReferringDoctorId = doctor.DoctorId;
      this.caseForToothModel.ReferralDoctorId = doctor.DoctorId;
    }
  }

  onParentCaseChange(event: TdoDropdownChange) {
    const parent: PatientCaseViewDataModel = event.value;
    this.model.Case.ParentPatientCaseId = parent.PatientCaseId;
  }

  onOpenToothSelector() {
    const dialogRef = this.dialog.open(ToothPickerComponent, {
      panelClass: 'dialog',
      data: {
        isMultiSelect: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // tooth selected
      if (result) {
        this.selectedTooth = result[0].toothModel;
        this.caseForToothModel.ToothId = this.selectedTooth.ToothId;
      }
    });
  }

  onOpenProcedureSelector() {
    // open a window to add a new procedure to this new case
    const dialogRef = this.dialog.open(CaseAddProcedureComponent, {
      panelClass: 'dialog',
      data: {
        isNewCase: true,
        isSingleSelection: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedCaseProcedure = result;
      this.caseForToothModel.CaseProcedureId = this.selectedCaseProcedure.CaseProcedureId;
      this.caseForToothModel.Description = this.staticDataService.getValidValueItemByItemId(result.enumProcedureTypeID)?.ItemDisplayValue;
    }, err => {
      //this.selectedCaseProcedure = result;
    });

  }
}
